import * as React from "react";

function SvgDefaultImagingSettings(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M11.166 7a.417.417 0 11-.833 0 .417.417 0 01.833 0zM9 11.5a.5.5 0 11-1 0 .5.5 0 011 0zM8.666 15.75a.417.417 0 11-.833 0 .417.417 0 01.833 0z"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.745 12.312a8.75 8.75 0 10-8.433 8.433 5.975 5.975 0 01-1.31-3.9 2.5 2.5 0 011.106-3.32 6.032 6.032 0 011.717-1.617 2.501 2.501 0 112.659-.886 5.975 5.975 0 014.261 1.29zM12 7a1.25 1.25 0 11-2.5 0A1.25 1.25 0 0112 7zm-2 4.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM8.25 17a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5z"
        fill="#fff"
      />
      <path d="M14.5 10a.5.5 0 100-1 .5.5 0 000 1z" fill="#fff" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.182 0C1.077 0 0 1.077 0 2.182v19.636C0 22.923 1.077 24 2.182 24h19.636C22.923 24 24 22.923 24 21.818V2.182C24 1.077 22.923 0 21.818 0H2.182zm19.704 13.517C21.96 13.022 22 12.514 22 12c0-5.523-4.477-10-10-10S2 6.477 2 12s4.477 10 10 10c.515 0 1.022-.039 1.517-.114a6 6 0 008.37-8.37z"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17 24a7 7 0 100-14 7 7 0 000 14zm0-1a6 6 0 100-12 6 6 0 000 12z"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20 15v4h-6v-3.368l.75-.632H20zm-5.25.632h.75v.631h-.75v-.631zm1.25 0h.75v.631H16v-.631zm2 0h-.75v.631H18v-.631zm.5 0h.75v.631h-.75v-.631zm-3.75 1.052h.75v.632h-.75v-.632zm1.25 0h.75v.632H16v-.632zm2 0h-.75v.632H18v-.632zm.5 0h.75v.632h-.75v-.632zm-3 1.053h-.75v.631h.75v-.631zm1.25 0H16v.631h.75v-.631zm.5 0H18v.631h-.75v-.631zm2 0h-.75v.631h.75v-.631z"
        fill="#fff"
      />
      <path
        d="M15 13h4v1h-4v-1zM21 15h1v4h-1v-4zM12 15h1v4h-1v-4zM15 20h4v1h-4v-1z"
        fill="#fff"
      />
    </svg>
  );
}

export default SvgDefaultImagingSettings;
